/*----- Core -----*/
import React   from 'react'
import styled  from 'styled-components'

/*----- Components -----*/
import LabelButton from '../../components/button/LabelButton'
import Spinner     from '../../components/commons/Spinner'
import Montserrat from '../../commons/mixins/fonts/Montserrat'

/*----- Styles -----*/
const StyledImageVisualizer = styled.article`
	.image-visualizer__list {
		display: grid;
		width: 100%;
		grid-template-columns: 116px 116px 116px;
	}
	.image-visualizer__item {
		height: 100px;
    width: 100px;
    display: block;
    border-radius: 8px;
    padding: 8px;
    background-position: center center;
    background-size: contain;
		background-repeat: no-repeat;
    margin: 8px;
		img {
			width: 100%;
		}
	}
	.image-visualizer__spinner-text {
		${ Montserrat(12, 600, 'black') };
	}
	.image-visualizer__spinner {
		display: flex;
		align-items: center;
		height: 100px;
    background: #f1f1f1;
    justify-content: center;
		border-radius: 8px;
		max-width: 300px;
		.spinner {
			transform: scale(0.2);
		}
	}
`
const ImageVisualizer = ({ images, multiple = false, onChange, imagesIsLoading}) => {
	function renderImages() {
		if (imagesIsLoading) {
			return (
				<div className="image-visualizer__spinner">
					<div className="image-visualizer__spinner-text">Cargando imagenes</div> <Spinner />
				</div>
			)
		} else if (images) {
			return (
				<div className="image-visualizer__list">
				{	
					images.map( (src,i) => (
						<div className="image-visualizer__item" key={i} style={{backgroundImage: `url(${src})`}}></div>
					))
				}
				</div>
			)
		}
	}
	return (
		<StyledImageVisualizer className="image-visualizer">
			<LabelButton htmlFor="files" invert content={ multiple ? 'Subir imágenes' : 'Subir imagen' } />
			<input type="file" style={{visibility: "hidden"}} id="files" name="filename" multiple={multiple} onChange={onChange} />
			{ renderImages() }
		</StyledImageVisualizer>
	)
}

export default ImageVisualizer